import React, { FC, ReactNode } from "react"

import ArticleDetailsHeader from "components/ArticleDetailsHeader/ArticleDetailsHeader"
import { Grid } from "components/Grid"
import { ArticleAny, Clamp } from "@/types"
import { ArticleMachineExt } from "models/ArticleMachineExt"
import { ArticleMachineInt } from "models/ArticleMachineInt"
import ArticleDetailsMachine from "./ArticleDetailsMachine"
import { ArticleEquipment } from "models/ArticleEquipment"
import ArticleDetailsEquipment from "./ArticleDetailsEquipment"

type ArticleDetailsProps = {
    article: ArticleAny
    descriptionClamp?: Clamp
    adjustableDescription?: boolean
    header?: boolean
    onEditInspectionSetting?: () => void
    onEdit?: () => void
}

const ArticleDetails: FC<React.PropsWithChildren<ArticleDetailsProps>> = ({
    article,
    descriptionClamp,
    adjustableDescription,
    header = false,
    onEditInspectionSetting,
    onEdit
}) => {
    let details: ReactNode = null

    if (article instanceof ArticleMachineExt
        || article instanceof ArticleMachineInt) {
        details = <ArticleDetailsMachine article={article} onEditInspectionSetting={onEditInspectionSetting} />
    } else if (article instanceof ArticleEquipment) {
        details = <ArticleDetailsEquipment article={article} onEditInspectionSetting={onEditInspectionSetting} />
    }

    return (
        <>
            {header &&
                <div className="mb-5 w-100">
                    <ArticleDetailsHeader
                        article={article}
                        descriptionClamp={descriptionClamp}
                        adjustableDescription={adjustableDescription}
                        onEdit={onEdit} />
                </div>
            }
            {!!details &&
                <Grid gap="6.4rem" className="w-100">
                    {details}
                </Grid>
            }
        </>
    )
}

export default ArticleDetails
